<template>
    <div id="app">
        <div id="h-page-loading" class="loading">
            <img src="images/erexx_loading.gif"/>
        </div>
        <div id="h-page-load" class="loadings hides">
            <img src="images/erexx_loading.gif"/>
        </div>
        <!--<img src="images/loading.gif"   class="fullscreenLoader" v-show="loading" alt="">-->
        <div v-show="!loading" style="display: none;">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
    import store from './store'

    export default {
        data() {
            return {
                loading: true,
                // limg: './images/loading.gif'
            }
        },
        created: function () {

            // const accessToken = localStorage.getItem('token')
            // const source = localStorage.getItem('source')
            //
            // if(accessToken && source) {
            //   var url = store.getters.getDomain
            //
            //   var a = new FormData();
            //   a.set('access_token', accessToken)
            //   a.set('source', source)
            //
            //   $.ajax({
            //     type: 'POST',
            //     url: `${url}api/v2/auth/find-user`,
            //     data: a,
            //     success: function (res) {
            //       console.log(res);
            //     }
            //   })
            // }
            this.loading = false
        },
        mounted() {
            var fadeTarget = document.getElementById("h-page-loading");
            var fadeEffect = setInterval(function () {
                if (!fadeTarget.style.opacity) {
                    fadeTarget.style.opacity = 1;
                }
                if (fadeTarget.style.opacity > 0) {
                    fadeTarget.style.opacity -= 0.1;
                } else {
                    clearInterval(fadeEffect);
                    fadeTarget.style.display = "none";
                }
            }, 100);
        }
    }
</script>